import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Colors } from "theme/colors";
import { fontQuicksand } from "theme/fonts";

export const StyledTabs = styled.div`
  max-width: 1280px;
`;

export const StyledTabsHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
`;

export const StyledTabsContainer = styled.div`
  padding: 2.5rem;
  background-color: ${Colors.WHITE};
  border-bottom-left-radius: 0.325rem;
  border-bottom-right-radius: 0.325rem;
  box-shadow: 0 0.59rem 1.175rem 0 rgba(0, 0, 0, 0.2);
`;

interface StyledTabProps {
  $active: boolean;
  $disabled: boolean;
}

export const StyledTab = styled.div<StyledTabProps>`
  border-radius: 0.65rem 0.65rem 0 0;
  padding: 0.88rem;
  cursor: pointer;
  background: ${Colors.PURPLE};
  color: ${Colors.WHITE};
  flex: 1;
  display: flex;
  justify-content: center;
  ${fontQuicksand()};
  font-size: 1.125rem;
  white-space: nowrap;

  &:hover {
    background-color: ${Colors.LIGHT_PURPLE};
  }

  ${(props) =>
    props.$active &&
    css`
      background: ${Colors.WHITE};
      color: ${Colors.BLUE};
      cursor: default;
      pointer-events: none;
      &:hover {
        background: ${Colors.WHITE};
        color: ${Colors.BLUE};
      }
    `}

  ${(props) =>
    props.$disabled &&
    css`
      pointer-events: none;
      text-decoration: line-through;
    `}
`;
